import {
  Select as InformedSelect,
  FormValue,
  FormValues,
  FieldProps,
} from 'informed'
import React from 'react'

import { overrideOptional } from '@emico/overrides'

type SelectProps<V = FormValue, VS = FormValues> = FieldProps<V, VS>

const Select = ({ children, ...props }: SelectProps) => (
  <InformedSelect {...props}>{children}</InformedSelect>
)

export default overrideOptional(Select)
